// tslint:disable:object-literal-sort-keys
type IMedia = "mobile" | "tablet" | "laptop" | "desktop";

export const size: { [key in IMedia]: number } = {
  mobile: 576, // Small devices
  tablet: 768, // Medium devices
  laptop: 992, // Large devices
  desktop: 1200, // Extra large devices
};

export default {
  size,
  mobile: `@media (min-width: ${size.mobile}px)`,
  tablet: `@media (min-width: ${size.tablet}px)`,
  laptop: `@media (min-width: ${size.laptop}px)`,
  desktop: `@media (min-width: ${size.desktop}px)`,
};
